import React, { createContext, useContext, useEffect, useState } from "react";
import { getCachevalue } from "./Services/CacheProviderService";

export const PermissionsContext = createContext(null);

export function PermissionsProvider({ children }) {
  const [role, setRole] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [screenAccess, setScreenAccess] = useState(null);

  const updatePermissions = (userInfo) => {
    const isAdmin = userInfo?.is_branch_admin || userInfo?.is_super_admin;
    setRole(isAdmin ? "admin" : "user");
    setSubscriptionData(userInfo?.package_access || null);
  };

  const loadScreenAccess = () => {
    try {
      const raw = getCachevalue("Scrren_access");
      setScreenAccess(raw ? JSON.parse(raw) : null);
    } catch {
      setScreenAccess(null);
    }
  };

  useEffect(() => {
    try {
      const loggedInUserInfo = getCachevalue("loggedInUserInfo");
      const packageAccess = getCachevalue("package_access");
      if (loggedInUserInfo && packageAccess) {
        const userInfo = JSON.parse(loggedInUserInfo);
        const subscriptionData = JSON.parse(packageAccess);
        const isAdmin = userInfo?.is_branch_admin || userInfo?.is_super_admin;
        setRole(isAdmin ? "admin" : "user");
        setSubscriptionData(subscriptionData);
      }
    } catch (e) {
      console.error("Error restoring subscription data:", e);
    }
    loadScreenAccess();
  }, []);

  return (
    <PermissionsContext.Provider value={{ role, subscriptionData, screenAccess, updatePermissions, loadScreenAccess }}>
      {children}
    </PermissionsContext.Provider>
  );
}

export const usePermissions = () => useContext(PermissionsContext);
